/**
 * @author Simeon Artamonov <simeon@cross-works.co.uk>
 * @company Cross Works Ltd
 */

import { computed } from 'vue'

type Size = 'Default' | 'Full' | 'Contained' | 'Contained_Small' | 'Contained_Small_Centred' | 'Narrow' | 'Narrow_Centred' | 'Two_Third' | 'Half' | 'Third'
type SizeMobile = 'Default' | 'Full' | 'Contained' | 'Contained_Small' | 'Contained_Small_Centred' | 'Narrow' | 'Narrow_Centred' | 'Two_Third' | 'Half' | 'Third'

interface ContainerSize {
  size?: Size
  sizeMobile?: SizeMobile
  height?: string
  heightMobile?: string
}

export const useContainerSize = (sizeConfig?: ContainerSize) => {
  const containerClass = computed(() => {
    const size = sizeConfig?.size || 'Default'
    const sizeMobile = sizeConfig?.sizeMobile || size

    // Convert size names to lowercase and handle special cases
    const formatSize = (s: string) => s.toLowerCase().replace('_', '-')

    return {
      [`container-${formatSize(size)}`]: true,
      [`container-${formatSize(sizeMobile)}-mobile`]: true
    }
  })

  const containerStyle = computed(() => {
    const height = sizeConfig?.height || 'auto'
    const heightMobile = sizeConfig?.heightMobile || height

    return {
      '--container-height': height,
      '--container-height-mobile': heightMobile
    }
  })

  const getContainerClasses = (baseClass: string) => {
    return {
      [baseClass]: true,
      ...containerClass.value 
    }
  }

  return {
    containerClass,
    containerStyle,
    getContainerClasses
  }
} 